<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-lg-6 mb-1">
              <div class="dataTables_length" id="tickets-table_length">
                <label class="d-inline-flex align-items-center">
                  Afișează
                  <select
                    aria-controls="tickets-table"
                    name="pageSize"
                    [(ngModel)]="reproductionsTableService.pageSize"
                    [disabled]="loadingDataSpinner"
                    (change)="changeTableRows($event)"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2"
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  intrări
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-lg-6 mb-1">
              <div
                id="tickets-table_filter"
                class="d-flex justify-content-end"
              >
                <button
                  class="btn btn-info btn-sm"
                  type="button"
                  placement="left"
                  [disabled]="loadingDataSpinner"
                  (click)="openTableSearchModal()"
                >
                  <span class="mdi mdi-magnify"></span>
                  Căutare
                </button>

                <button
                  class="btn btn-blue btn-sm"
                  type="button"
                  placement="left"
                  [disabled]="loadingDataSpinner"
                  (click)="openReproductiiModal()"
                  *ngIf="currentRoute.includes('/exploatatie/') && (isAdmin || isOperator || isFermier)"
                >
                  <span class="mdi mdi-plus-circle"></span>
                  Adaugă reproducție (Anexa 3)
                </button>

                <button
                  *ngIf="isAdmin || isOperator"
                  class="btn btn-success btn-sm"
                  type="button"
                  (click)="exportTableXLSX()"
                  [disabled]="loadingDataSpinner || reproductionsLength === 0"
                  ngbTooltip="Se vor exporta doar datele afișate"
                  placement="bottom"
                >
                  <i class="mdi mdi-file-excel"></i>
                  Exportă XLS
                </button>
              </div>
            </div>
            <!-- End search -->
          </div>

          <!-- Table -->
          <div class="table-responsive" #reproductionsTable>
            <table
              id="reproductions-datatable"
              class="table datatables dt-responsive nowrap table-hover"
            >
              <thead>
                <tr>
                  <th>Tip reproducție</th>
                  <th>Femelă</th>
                  <th>Taur</th>
                  <th>Dată/Interval montă</th>
                  <th>Autorizație montă</th>
                  <th>Operator I.A.</th>
                  <th>Anexa 3</th>
                </tr>
              </thead>

              <div
                *ngIf="loadingDataSpinner"
                class="spinner-border text-info table-spinner avatar-lg"
                role="status"
              ></div>

              <ngb-alert
                *ngIf="!loadingDataSpinner && reproductionsTableService.totalRecords === 0"
                type="danger"
                class="text-center search-error"
                [dismissible]="false"
              >
                Nu a fost găsită nici o reproducție în urma căutării dvs.
              </ngb-alert>

              <tbody [ngClass]="{ disabled: loadingDataSpinner }">
                <tr *ngFor="let reproduction of reproductions">
                  <td>{{reproduction.tip_reproductie_text}}</td>
                  <td>{{reproduction.femela}}</td>
                  <td>{{reproduction.taur}}</td>
                  <td>{{reproduction.interval_monta}}</td>
                  <td>{{reproduction.autorizatie_monta}}</td>
                  <td>{{reproduction.operator_ia}}</td>
                  <td>
                    <a
                      *ngIf="reproduction.anexa3id !== null"
                      href="javascript: void(0);"
                      (click)="openAnexa3(reproduction.anexa3id)"
                    >{{reproduction.anexa3}}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End table -->
          <div
            class="row justify-content-lg-between align-items-lg-center mt-2"
            *ngIf="reproductionsTableService.totalRecords > 0"
          >
            <div class="col-sm-12 col-lg-6">
              <div
                class="dataTables_info mb-2"
                id="tickets-table_info"
                role="status"
                aria-live="polite"
              >
                Afișează de la
                {{ reproductionsTableService.startIndex }} la
                {{ reproductionsTableService.endIndex }} din
                {{ reproductionsTableService.totalRecords }}
                intrări
              </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-lg-6">
              <div class="text-lg-right float-lg-right pagination-rounded">
                <ngb-pagination
                  [disabled]="loadingDataSpinner"
                  [collectionSize]="reproductionsLength"
                  [(page)]="reproductionsTableService.page"
                  [pageSize]="reproductionsTableService.pageSize"
                  [maxSize]="5"
                  (pageChange)="changeTablePage($event)"
                >
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-table-search-modal
  [open]="openSearchModal"
  [modalType]="modalType"
  (searchingData)="filterSearch($event)"
>
</app-table-search-modal>

<app-rep-fat-modal
  [data]="modalData"
  (callbackResult)="getModalResult($event)"
>
</app-rep-fat-modal>
